import { writable } from 'svelte/store';
import { browser, dev } from '$app/environment';

import device from '$lib/utils/functions/device';

export const pwaInstallPrompt = writable();
export const alreadyInstalled = writable();

alreadyInstalled.subscribe((INSTALLED) => {
    if (!browser || typeof INSTALLED === 'undefined') return;

    /*
    // Installation ID
    let d_id = localStorage.getItem('D_ID');
    if (!d_id) {
        d_id = window.crypto.getRandomValues(new Uint32Array(1))[0].toString(16);
        localStorage.setItem('D_ID', d_id);
    }
    const cookieWindow = 60 * 60 * 24 * 365;
    document.cookie = `d_id=${d_id}; max-age=${cookieWindow}; path=/api/auth; SameSite=Lax; Secure`; // TODO: Path
    document.cookie = `d_s=${INSTALLED ? 1 : 0};  max-age=${cookieWindow}; path=/api/auth; SameSite=Lax; Secure`; // TODO : Path
    */

    return;
});

export const pwaPromptListener = async () => {
    alreadyInstalled.set(device.isPWAInstalled(window)); // On fresh load, set the alreadyInstalled store to null/true

    // App not installed, but can be prompted
    window.addEventListener('beforeinstallprompt', (event) => {
        event.preventDefault(); // No autoprompt!

        // If the app has been installed before, but we see beforeinstallprompt, then they have uninstalled TODO : Uninstalled Handler
        localStorage.removeItem('APP_INSTALLED');
        alreadyInstalled.set(false);
        // Move prompt to a store, and the PWAPrompt Component can subscribe and display in our featured positions
        pwaInstallPrompt.set(event);
    });

    // PWA Installed - Chrome, Edge, Chrome Android, Samsung Internet, Webview Android. No FF,Opera,Safari, iOS support.
    window.addEventListener('appinstalled', () => {
        localStorage.setItem('APP_INSTALLED', 'true'); // Set localstorage app installed
        alreadyInstalled.set(true); // Update the store, so PWAPrompt can disappear!
    });
};

// Register service worker (only after page has fully load)
const registerServiceWorkerAction = async (context) => {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker
            .register('/service-worker.js', {
                type: dev ? 'module' : 'classic',
                scope: '/'
            })
            .then(() => {
                console.log('registered main SW');
                context.fussyDependanciesReady.mainServiceWorkerRegistered.set(true); // Writable store, (default false).
            })
            .catch((error) => {
                console.error('Error registering service worker', error);
            });
    }
    return;
};
export const registerServiceWorker = async (context) => {
    if (window.document.readyState === 'complete') {
        registerServiceWorkerAction(context);
        return;
    }
    window.addEventListener('load', () => {
        registerServiceWorkerAction(context);
    });
};
